const toNumber = (v) => (isFinite(Number(v)) ? Number(v) : 0);
const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const StatsPanel = ({ t, stats, totalsFromStats, hasCard, hasCash, hasCheck, hasBank }) => {
  const getTotal = (preferA, preferB) => {
    const a = toNumber(preferA);
    if (a) return a;
    const b = toNumber(preferB);
    return b;
  };

  const cash = {
    count: toNumber(stats?.cashDonationsStats?.count),
    avg: isFinite(totalsFromStats?.cashAvg) ? totalsFromStats.cashAvg : 0,
    max: isFinite(totalsFromStats?.cashMax) ? totalsFromStats.cashMax : 0,
    total: getTotal(stats?.cashDonationsStats?.total, totalsFromStats?.cashSum),
  };

  const card = {
    count: toNumber(stats?.transactionsStats?.count),
    avg: isFinite(totalsFromStats?.cardAvg) ? totalsFromStats.cardAvg : 0,
    max: isFinite(totalsFromStats?.cardMax) ? totalsFromStats.cardMax : 0,
    total: getTotal(stats?.transactionsStats?.total, totalsFromStats?.cardSum),
  };

  const check = {
    count: toNumber(stats?.checkDonationsStats?.count),
    avg: isFinite(totalsFromStats?.checkAvg) ? totalsFromStats.checkAvg : 0,
    max: isFinite(totalsFromStats?.checkMax) ? totalsFromStats.checkMax : 0,
    total: getTotal(stats?.checkDonationsStats?.total, totalsFromStats?.checkSum),
  };

  const bank = {
    count: toNumber(stats?.bankTransfersStats?.count),
    avg: isFinite(totalsFromStats?.bankAvg) ? totalsFromStats.bankAvg : 0,
    max: isFinite(totalsFromStats?.bankMax) ? totalsFromStats.bankMax : 0,
    total: getTotal(stats?.bankTransfersStats?.total, totalsFromStats?.bankSum),
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full border-separate border-spacing-y-2">
        <thead>
          <tr className="[&_th]:px-3 [&_th]:py-2 text-left text-gray-500">
            <th></th>
            {hasCash && <th>{t("cash") || "Cash"}</th>}
            {hasCheck && <th>{t("check") || "Check"}</th>}
            {hasBank && <th>{t("bank_eft") || "Bank EFT"}</th>}
            {hasCard && <th>{t("card") || "Card"}</th>}
          </tr>
        </thead>
        <tbody className="[&_td]:px-3 [&_td]:py-2">
          <tr className="bg-white rounded-lg shadow-sm">
            <td className="text-gray-500">{t("no_of_donations") || "Number of donations"}</td>
            {hasCash && <td><label className="text-gray-700">{cash.count}</label></td>}
            {hasCheck && <td><label className="text-gray-700">{check.count}</label></td>}
            {hasBank && <td><label className="text-gray-700">{bank.count}</label></td>}
            {hasCard && <td><label className="text-gray-700">{card.count}</label></td>}
          </tr>
          <tr className="bg-white rounded-lg shadow-sm">
            <td className="text-gray-500">{t("average_donation") || "Average donation"}</td>
            {hasCash && <td><label className="text-gray-700">{formatCurrency(cash.avg)} $</label></td>}
            {hasCheck && <td><label className="text-gray-700">{formatCurrency(check.avg)} $</label></td>}
            {hasBank && <td><label className="text-gray-700">{formatCurrency(bank.avg)} $</label></td>}
            {hasCard && <td><label className="text-gray-700">{formatCurrency(card.avg)} $</label></td>}
          </tr>
          <tr className="bg-white rounded-lg shadow-sm">
            <td className="text-gray-500">{t("maximum_donation") || "Maximum donation"}</td>
            {hasCash && <td><label className="text-gray-700">{formatCurrency(cash.max)} $</label></td>}
            {hasCheck && <td><label className="text-gray-700">{formatCurrency(check.max)} $</label></td>}
            {hasBank && <td><label className="text-gray-700">{formatCurrency(bank.max)} $</label></td>}
            {hasCard && <td><label className="text-gray-700">{formatCurrency(card.max)} $</label></td>}
          </tr>
          <tr className="bg-white rounded-lg shadow-sm">
            <td className="text-gray-500">{t("total_donations") || "Total donations"}</td>
            {hasCash && <td><label className="text-gray-700">{formatCurrency(cash.total)} $</label></td>}
            {hasCheck && <td><label className="text-gray-700">{formatCurrency(check.total)} $</label></td>}
            {hasBank && <td><label className="text-gray-700">{formatCurrency(bank.total)} $</label></td>}
            {hasCard && <td><label className="text-gray-700">{formatCurrency(card.total)} $</label></td>}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default StatsPanel;
